/*
 * Copyright (c) 2021. Lukas Tschaftary
 *
 * NOTICE:  All information contained herein is, and remains the property of Lukas Tschaftary and his suppliers, if any.
 * The intellectual and technical concepts contained herein are proprietary to Lukas Tschaftary and its suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained from Lukas Tschaftary.
 */

import React from "react";


/**
 * @typedef {Object} FetchResponse
 * @property {Object} output - The output for example of insert
 * @property {Object[]} recordset - A Array with the values
 * @property {Array[]} recordsets - A Array in a Array with the records
 * @property {number} rowsAffected - The number of rows effected
 */

const Installation = "SW_pfaffenhofen" //SW_pfaffenhofen


const Settings = function () {

    function get() {
        return fetchProxy(("V2/get_settings"), '', 'GET')
    }

    function setSetting(newValue, settingName, settingScope) {
        return fetchProxy(("V2/set_setting?" + new URLSearchParams({
            newValue: newValue,
            settingName: settingName,
            settingScope: settingScope,
        })), '', 'GET')
    }


    return {
        get: get,
        setSetting: setSetting,
    }


}
()

const Loggin = function () {

    function get(clientId, paginationStart) {
        return fetchProxy(("V2/get_logs?" + new URLSearchParams({
            paginationStart: paginationStart || 0,
            clientId: clientId,

        })), '', 'GET')
    }


    return {
        get: get,
    }


}
()

const Data = function () {

    function get(deviceName, paginationStart) {
        return fetchProxy(("V2/get_row_data?" + new URLSearchParams({
            paginationStart: paginationStart || 0,
            deviceName: deviceName,
        })), '', 'GET')
    }


    return {
        get: get,
    }


}
()
const Database = function () {

    function getGraph(tableName, columnNames, interval) {
        return fetchProxy(("V2/get_graph?" + new URLSearchParams({
            tableName: tableName,
            columnNames: columnNames,
            interval: interval,
        })), '', 'GET')
    }

    function getGraphWithRange(tableName, columnNames, startDate, endDate) {
        return fetchProxy(("V2/get_graph_with_range?" + new URLSearchParams({
            tableName: tableName,
            columnNames: columnNames,
            startDate: Math.floor(new Date(startDate).getTime() / 1000),
            endDate: Math.floor(new Date(endDate).getTime() / 1000),
        })), '', 'GET')
    }

    function getMilestones(tableName) {
        return fetchProxy(("V2/milestone_data?" + new URLSearchParams({
            installation: Installation,
            name: tableName,
        })), '', 'GET')
    }


    function getAggregationValue(tableName, interval, columnName) {
        return fetchProxy(("V2/get_aggregation_value?" + new URLSearchParams({
            installation: Installation,
            tableName: tableName,
            interval: interval,
            columnName: columnName,
        })), '', 'GET')
    }


    return {
        getGraph: getGraph,
        getAggregationValue: getAggregationValue,
        getMilestones: getMilestones,
        getGraphWithRange: getGraphWithRange,
    }


}
()


const fetchProxy = async function (endpointUrl, urlencoded, method = "POST") {

    let headers = new Headers();
    // headers.append("Content-Type", "application/x-www-form-urlencoded");
    // headers.append("Authorization", `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`);

    // const queryString = (method === "GET") ? ("?" + objToQueryString(urlencoded)) : ("")


    const requestOptions = (method === "POST") ? ({
        method: method,
        headers: headers,
        body: urlencoded,
        redirect: 'follow'
    }) : ({
        method: method,
        headers: headers,
        redirect: 'follow'
    });


    return (new Promise((resolve) => {
        fetch(process.env.REACT_APP_API_ENDPOINT || "https://api.ereneo.com/" + endpointUrl, requestOptions)
            .then(response => response.json())
            .then(data => {
                resolve(checkAPIResult(data, endpointUrl))
            })
            .catch((error) => {

                    console.log(error);
                    return setTimeout(() => {
                        console.log('retry');
                        return fetch(process.env.REACT_APP_API_ENDPOINT || "https://api.ereneo.com/" + endpointUrl, requestOptions)
                            .then(response => response.json())
                            .then(data => {
                                resolve(checkAPIResult(data, endpointUrl))
                            }).catch((error) => {
                                resolve([])

                            })


                    }, 1400)


                }
            );

    }))


}


const checkAPIResult = function (data, path) {
    if (data.hasOwnProperty("code")) {
        // store.dispatch(triggerError({
        //     title: data.originalError.info.message,
        //     text: 'Endpoint Path: ' + path,
        //     linkShowMe: <div><a href={process.env.REACT_APP_API_ENDPOINT + path} target={"_blank"}
        //                         rel="noopener noreferrer"> Show me the api
        //         results</a></div>,
        //     errorSourcePath: "",
        // }))
        return {recordsets: [[]], recordset: [], error: true}
    } else if (data.hasOwnProperty("success")) {
        if (data.success === false) {
            // store.dispatch(triggerError({
            //     title: data.errorMessage,
            //     text: 'Endpoint Path: ' + path,
            //     linkShowMe: <div/>,
            //     errorSourcePath: "",
            // }))
            return {}
        } else {
            return data
        }
    } else {
        return data
    }
}


export {
    Settings,
    Loggin,
    checkAPIResult,
    Data,
    Database

};